import type { FC } from "react";
import React, { Suspense } from "react";
import { CircularProgress } from "@material-ui/core";

import ErrorBoundary from "../../../../basic/error_boundary";
import { ClassResultsContainer } from "../class_results_container/class_results_container";

type Props = {
  classId: number;
};

export const ClassResultsSuspense: FC<Props> = ({ classId }: Props) => (
  <ErrorBoundary>
    <Suspense fallback={<CircularProgress />}>
      <ClassResultsContainer classId={classId} />
    </Suspense>
  </ErrorBoundary>
);
